var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 8.83333C1.40817 8.83333 0.666504 9.575 0.666504 10.5V13.8333C0.666504 14.7583 1.40817 15.5 2.33317 15.5H5.6665C6.5915 15.5 7.33317 14.7583 7.33317 13.8333V10.5C7.33317 9.575 6.5915 8.83333 5.6665 8.83333H2.33317ZM5.83317 10.0833L6.7165 10.9583L3.3915 14.25L1.28317 12.125L2.17484 11.25L3.39984 12.4917L5.83317 10.0833ZM2.33317 0.5C1.40817 0.5 0.666504 1.24167 0.666504 2.16667V5.5C0.666504 6.425 1.40817 7.16667 2.33317 7.16667H5.6665C6.5915 7.16667 7.33317 6.425 7.33317 5.5V2.16667C7.33317 1.24167 6.5915 0.5 5.6665 0.5H2.33317ZM2.33317 2.16667H5.6665V5.5H2.33317V2.16667ZM8.99984 2.16667H17.3332V3.83333H8.99984V2.16667ZM8.99984 13.8333V12.1667H17.3332V13.8333H8.99984ZM8.99984 7.16667H17.3332V8.83333H8.99984V7.16667Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactIcon);
export default __webpack_public_path__ + "static/media/transact-icon.8a2f0a7439a7fdbf63b8e39187a9d924.svg";
export { ForwardRef as ReactComponent };